// Google grants either the narrow `calendar.events` scope or the broad
// `calendar` scope depending on how the connection was created; the server's
// isCalendarConnection (services/calendars.ts) gates on the broad scope, so
// matching only the narrow one missed expired broad-scope accounts.
const GOOGLE_CALENDAR_SCOPE = 'https://www.googleapis.com/auth/calendar.events'
const GOOGLE_CALENDAR_BROAD_SCOPE = 'https://www.googleapis.com/auth/calendar'
const MICROSOFT_CALENDAR_SCOPE = 'Calendars.ReadWrite'

/** Whether a connection's scopes grant calendar access, regardless of which of the two Google scopes it holds. */
export function isCalendarCapableConnection(connection: {
  providerName: string
  scopes?: Array<string> | null
}): boolean {
  if (connection.providerName === 'google') {
    return Boolean(
      connection.scopes?.includes(GOOGLE_CALENDAR_SCOPE) || connection.scopes?.includes(GOOGLE_CALENDAR_BROAD_SCOPE),
    )
  }
  if (connection.providerName === 'microsoft') {
    return Boolean(connection.scopes?.includes(MICROSOFT_CALENDAR_SCOPE))
  }
  return false
}

/**
 * Whether the server will actually serve calendars for this connection.
 * Mirrors isCalendarConnection (services/calendars.ts), which only migrates
 * Google rows holding the broad scope, so a narrow-scope-only row is
 * "capable" for display purposes but can never sync.
 */
export function isCalendarSyncEligibleConnection(connection: {
  providerName: string
  scopes?: Array<string> | null
}): boolean {
  if (!isCalendarCapableConnection(connection)) {
    return false
  }
  return connection.providerName !== 'google' || Boolean(connection.scopes?.includes(GOOGLE_CALENDAR_BROAD_SCOPE))
}
